module.exports = __webpack_public_path__ + "static/img/3.402e586.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/3.png
// module id = DPab
// module chunks = 0